module.exports = __webpack_public_path__ + "static/media/3_12.c755b440.png";